import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  optionNav: sessionStorage.getItem("optionNav"),
  dataConfigNav: sessionStorage.getItem("dataConfigNav"),
  dataConfigNavs: sessionStorage.getItem("dataConfigNavs"),
  macNumber: sessionStorage.getItem("deviceIp"),
  imgNav: sessionStorage.getItem("imgNav"),
  alarmrecord: sessionStorage.getItem("alarmrecord"),
  AlarmLog: [] || localStorage.getItem("key"),
  tabs: [] || localStorage.getItem("tabs"),
  activevalue: "",
  formPaper:{} || localStorage.getItem("formPaper"),
};

const mutations = {
  // 判断是否隐藏头不导航条
  optionNavActive(state, type) {
    sessionStorage.setItem("optionNav", type);
    state.optionNav = type;
  },

  dataConfigNavActive(state, type) {
    sessionStorage.setItem("dataConfigNav", type);
    state.dataConfigNav = type;
  },
  dataConfigNavsaActive(state, type) {
    sessionStorage.setItem("dataConfigNavs", type);
    state.dataConfigNavs = type;
  },
  imgNavActive(state, type) {
    sessionStorage.setItem("imgNav", type);
    state.imgNav = type;
  },

  getmacNumber(state, val) {
    sessionStorage.setItem("deviceIp", val);
    state.macNumber = val;
  },

  getalarmrecord(state, val) {
    sessionStorage.setItem("alarmrecord", val);
    state.alarmrecord = val;
  },
  AlarmLogactive(state, val) {
    state.AlarmLog.push(val);
    localStorage.setItem("key", JSON.stringify(state.AlarmLog));
  },
  gettabs(state, val) {
    state.tabs.push(val);
    localStorage.setItem("tabs", JSON.stringify(state.tabs));
  },
  setactivevalue(state, val) {
    state.activevalue = val;
    sessionStorage.setItem("values", state.activevalue);
  },
  getstabs(state, val) {
    // console.log(val);
    let obj2 = {};
    val = val.reduce((pre, cur) => {
      if (obj2[cur.name]) {
        pre.map(item => (item.name === cur.name ? item.path : ""));
      } else {
        obj2[cur.name] = true && pre.push(cur);
      }
      return pre;
    }, []);
    // console.log(val);

    // state.tabs = val;
    localStorage.setItem("tabs", JSON.stringify(val));
  },
  AlarmLogactives(state, val) {
    localStorage.removeItem("key");
  },
  RemoveAlarmLog(state, val) {
    state.AlarmLog = val;
  },
  formPaper(state, val){
    localStorage.setItem("formPaper", JSON.stringify(val));
  }
};
const actions = {};
export default new Vuex.Store({
  state,
  mutations,
  actions
});



// WEBPACK FOOTER //
// ./src/store/index.js